import React from "react";
import { getValue } from "@utils/lodash";

function ComplianceDetailsSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <defs>
            <clipPath id="clip-path-compliance-details">
            <rect id="Rectangle_18144" data-name="Rectangle 18144" width="18" height="18" transform="translate(-13764 -6788)" fill="#fff"/>
            </clipPath>
        </defs>
        <g id="Group_10472" data-name="Group 10472" transform="translate(-159 -875)">
            <g id="Group_10458" data-name="Group 10458" transform="translate(12227 7460)">
            <circle id="Ellipse_3667" data-name="Ellipse 3667" cx="16" cy="16" r="16" transform="translate(-12068 -6585)" fill="#f3e8fc"/>
            <g id="Mask_Group_254" data-name="Mask Group 254" transform="translate(1703 210)" clip-path="url(#clip-path-compliance-details)">
                <path id="assured_workload_FILL0_wght300_GRAD0_opsz24" d="M4.611-6.237V-12.1H5.793v5.865Zm4.337,0V-12.1h1.183v5.865ZM2.26-13.667V-14.78l7.279-3.534,7.279,3.534v1.113H2.26ZM5.068-14.84H14.01L9.539-16.99ZM2.26-3.5V-4.673h9.131q.024.313.068.6a5.2,5.2,0,0,0,.124.577ZM13.285-8.771V-12.1h1.183v2.745Zm2.563,7.708A3.6,3.6,0,0,1,13.761-2.5,4.122,4.122,0,0,1,12.936-5V-6.839l2.912-1.444L18.76-6.839V-5a4.122,4.122,0,0,1-.825,2.5A3.6,3.6,0,0,1,15.848-1.064Zm-.572-2.211,2.566-2.533-.661-.656L15.276-4.6l-.769-.762-.661.668ZM5.068-14.84h0Z" transform="translate(-13765.51 -6769.311)" fill="#8339cb"/>
            </g>
            </g>
        </g>
    </svg>
  );
}

export default ComplianceDetailsSvgComponent;
